import React from "react";
import { useParams } from 'react-router-dom';

function NodeDetail () {
    // const {id} = useParams<{id: any}>();
    // let archivo2 = `http://158.69.186.131:8080/alfresco/service/api/node/content/workspace/SpacesStore/${id}?a=false&alf_ticket=${localStorage.ticket}`;
    
    return (
        <div style={{position: "absolute", width: "100%", height: "100%"}}>
            {/* <iframe src={archivo2}
            width="100%" height="100%"></iframe> */}
        </div>

    );
}

export default NodeDetail;